<template>
  <div id="share_select_outer">
    <span style="font-size: 1rem;" >分享到</span>
    <a
      v-for="(item, index) in itemList"
      class="iconfont"
      href="javascript:void(null);"
       :key="'share_item_' + index"
       @click="shareItemClicked(item)">
      {{item.iconText}}
    </a>

    <share-card v-if="showQrCard" v-bind:url="shareUrl" v-on:close="closeShareCard" />
  </div>
</template>

<script>
import Clipboard from "clipboard";
import ShareCard from "./ShareCard";

export default {
  name: "ShareSelect",
  props: {
    shareObject: {
      type: Object,
      value: null
    }
  },
  components: {
    ShareCard,
  },
  data() {
    return {
      itemList: [
        {
          text: '微信好友',
          iconText: '\ue609',
          type: 'wetchat'
        },
        {
          text: 'QQ',
          iconText: '\ue6f4',
          type: 'qzone'
        },
        {
          text: '新浪微博',
          iconText: '\uea8c',
          type: 'weibo'
        },

        {
          text: '复制',
          iconText: '\ue622',
          type: 'copy'
        },
      ],
      showWeChat: true,
      showQrCard: false,
    }
  },
  computed: {
    shareUrl() {
      return this.shareObject.link;
    }
  },
  mounted() {
    this.showWeChat = !this.isWeixin();
    if (!this.showWeChat) {
      this.itemList = this.itemList.splice(1);
    }
    this.configShareWx(encodeURIComponent(location.href), this.shareObject);
  },
  methods: {
    closeShareCard() {
      this.showQrCard = false;
    },
    shareItemClicked(item) {
      let type = item.type;
      if (type == 'copy') {
        this.copyUrl();
        return;
      }

      if (type == 'wetchat') {
        this.showQrCard = true;
        return;
      }

      this.shareWithLink(item.type);
    },
    copyUrl() {
      let url = window.location.href;
      let clip = new Clipboard('#share_select_outer',{
        text: function () {
          return url;
        }
      });
      let _this = this;

      clip.on('success', e => {
        _this.$toast('复制成功！');
      });

      clip.on('error', e => {
        _this.$toast('复制失败！');
      });
    },

    shareWithLink(type) {
      if (this.shareObject == null) {
        return
      }
      let title = encodeURIComponent(this.shareObject.title);
      // var link = encodeURIComponent(this.shareObject.link);
      // let link = encodeURIComponent(this.shareObject.link);
      let link = encodeURI(this.shareObject.link);
      let summary = encodeURIComponent(this.shareObject.desc);
      let image = encodeURIComponent(this.shareObject.imgUrl);
      if (type == "weibo") {
        let shareUrl = 'https://v.t.sina.com.cn/share/share.php?title="123"';     //真实的appkey，必选参数
        shareUrl += '&url='+ link;     //参数url设置分享的内容链接|默认当前页location，可选参数
        shareUrl += '&title=' + title;    //参数title设置分享的标题|默认当前页标题，可选参数
        shareUrl += '&source=' + '';
        shareUrl += '&sourceUrl=' + '';
        shareUrl += '&content=' + 'utf-8';   //参数content设置页面编码gb2312|utf-8，可选参数
        shareUrl += '&pic=' + image;  //参数pic设置图片链接|默认为空，可选参数
        window.open(shareUrl, '_blank');
        return;
      }
      if (type == "tx") {
        window.open("https://v.t.qq.com/share/share.php?url=" + link + "&title=" + title + "&pic=" + image);
      }
      if (type == "qzone") {
        let shareUrl = 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?';
        shareUrl += 'url=' + link;   //参数url设置分享的内容链接|默认当前页location
        shareUrl += '&showcount=' + 1;      //参数showcount是否显示分享总数,显示：'1'，不显示：'0'，默认不显示
        shareUrl += '&desc=' + summary;    //参数desc设置分享的描述，可选参数
        shareUrl += '&title=' + title;    //参数title设置分享标题，可选参数
        shareUrl += '&pics=' + image;
        window.open(shareUrl, '_blank');
        return;
      }
      if (type == "rr") {
        window.open("https://widget.renren.com/dialog/share?resourceUrl=" + link + "&title=" + title  + "&pic=" + image);
        return;
      }
      if (type == "douban") {
        window.open("https://www.douban.com/recommend/?url=" + link + "&title=" + title + "&image=" + image);
        return;
      }
    }
  }
}
</script>

<style scoped>

  #share_select_outer {
    /*background-color: yellow;*/
    display: inline-block;
  }

  #share_select_outer a, #share_select_outer a:visited {
    text-decoration: none;
    color: #999;
    font-size: 1.5rem;
    font-weight: bold;
  }

  #share_select_outer a:hover {
    color: #fc1a34;
  }

  #share_select_outer a:not(:first-child) {
    margin-left: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/share/ShareSelect.vue